import SingleChoice from '@/components/SingleChoice.vue'
import MultipleChoice from '@/components/MultipleChoice.vue'
import FillInTheBlank from '@/components/FillInTheBlank.vue'
import ImageChoice from '@/components/ImageChoice.vue'
import RATE from '@/components/DRate.vue'
import Trend from '@/components/DTrend.vue'
import InformationCollection from '@/components/InformationCollection.vue'
import { QuestionType } from '@/types'
export function useComponent() {
  const is = (type: QuestionType) => {
    switch (type) {
      case QuestionType.SingleChoice:
        return SingleChoice
      case QuestionType.MultipleChoice:
        return MultipleChoice
      case QuestionType.FillInTheBlank:
        return FillInTheBlank
      case QuestionType.ImageChoice:
        return ImageChoice
      case QuestionType.RATE:
        return RATE
      case QuestionType.Trend:
        return Trend
      case QuestionType.InformationCollection:
        return InformationCollection
      default:
        return ''
    }
  }
  return {
    is,
  }
}
